<div class="PGBookingsSlotSummary">
    @if (slotStart != null) {
        <div class="me-3">
            <i class="fa-regular fa-clock me-2"></i>
            <span>{{slotStart}}@if (slotEnd != null) {
                - {{slotEnd}}
            }</span>
        </div>
    }

    @if(!isCumulativeBooking()) {
        @if (getSlotCapacity(); as capacity) {
            <div class="me-3 PGBookingsSlotSummary-Capacity">
                <i class="fa-regular fa-chair fa-fw me-2"></i>
                <small class="PGBookingsSlotSummary-StatusList">
                    <span>{{ 'pg-bookings-slot-summary.capacity' | locTranslate }}</span>
                    <span>{{ capacity }}</span>&nbsp;
                </small>
            </div>
        }
    
        @if (hasSomeParticipants()) {
            <div class="me-3 PGBookingsSlotSummary-Participants">
                <i class="fa-regular fa-users fa-fw me-2"></i>
                <small class="PGBookingsSlotSummary-StatusList">
                    <span>{{ 'pg-bookings-slot-summary.participants' | locTranslate }}</span>
                    @if (slotSummary.participants.pending > 0) {
                        <span> {{ 'pg-bookings-slot-summary.participants-pending' | locTranslate:'num':slotSummary.participants.pending }}</span>
                    }
                    @if (slotSummary.participants.available > 0) {
                        <span class="text-primary"> {{ 'pg-bookings-slot-summary.participants-available' | locTranslate:'num':slotSummary.participants.available }}</span>
                    }
                    @if (slotSummary.participants.confirmed > 0) {
                        <span class="text-success"> {{ 'pg-bookings-slot-summary.participants-confirmed' | locTranslate:'num':slotSummary.participants.confirmed }}</span>
                    }
                </small>
            </div>
        }
    }

    @if (hasSomeBookings()) {
        <div class="PGBookingsSlotSummary-Bookings">
            <i class="fa-regular fa-book fa-fw me-2"></i>
            <small class="PGBookingsSlotSummary-StatusList">
                <span>{{ 'pg-bookings-slot-summary.' + (isCumulativeBooking() ? 'cumulative' : 'bookings') | locTranslate }}</span>
                @if (slotSummary.bookings.pending > 0) {
                    <span>{{ 'pg-bookings-slot-summary.bookings-pending' | locTranslate:'num':slotSummary.bookings.pending }}</span>
                }
                @if (slotSummary.bookings.available > 0) {
                    <span class="text-primary">{{ 'pg-bookings-slot-summary.bookings-available' | locTranslate:'num':slotSummary.bookings.available }}</span>
                }
                @if (slotSummary.bookings.confirmed > 0) {
                    <span class="text-success">{{ 'pg-bookings-slot-summary.bookings-confirmed' | locTranslate:'num':slotSummary.bookings.confirmed }}</span>
                }
                @if (slotSummary.bookings.canceled > 0) {
                    <span class="text-danger">{{ 'pg-bookings-slot-summary.bookings-canceled' | locTranslate:'num':slotSummary.bookings.canceled }}</span>
                }
                @if (slotSummary.bookings.handled > 0) {
                    <span class="text-primary">{{ 'pg-bookings-slot-summary.bookings-handled' | locTranslate:'num':slotSummary.bookings.handled }}</span>
                }
            </small>
        </div>
    }
</div>